export enum EmployeePageTab {
  OFFERS = 'Offers',
  PAGES = 'Pages',
}
